<template>
  <tr>
    <td class="font-weight-bold">Total Geral</td>

    <template v-if="meses.length > 0">
      <td
        v-for="(referencia, index) in meses"
        :key="index"
        class="font-weight-medium cursor-pointer"
        @click="abrirDialogExportacao(referencia)"
      >
        {{`R$ ${formataValor(somaValoresColunaMes(referencia))}`}}
      </td>
    </template>

    <template v-else>
      <td colspan="13">
        <v-progress-linear
          indeterminate
          rounded
          color="#F5A9A9"
        ></v-progress-linear>
      </td>
    </template>
  </tr>
</template>

<script>
import formatarValoresBi from "../../../../helpers/formatarValoresBi.js"

export default {
  name: "LinhaTotalizadora",
  props: {
    itens: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    valoresItens() {
      return Object.values(this.itens);
    },
    meses() {
      if (!this.itens.NIVEL_BAIXO) {
        return [];
      }

      return this.itens.NIVEL_BAIXO.map(item => {
        const {mes, ano, id_grupo} = item;
        return {mes, ano, id_grupo, nivel_servico: ''};
      });
    },
  },
  methods: {
    somaValoresColunaMes({mes, ano}) {
      const TOTALIZA_COLUNA = (acumulador, item) => {
        const itemReferenciado = item.filter(
          subItem => (subItem.ano == ano && subItem.mes == mes)
        );

        if (itemReferenciado[0]) {
          return acumulador + parseFloat(itemReferenciado[0].total_ruptura);
        }

        return acumulador;
      }

      return this.valoresItens.reduce(TOTALIZA_COLUNA, 0)
    },
    formataValor(numero) {
      return formatarValoresBi(numero);
    },
    abrirDialogExportacao (item) {
      this.$emit('click:coluna', item)
    }
  }
}
</script>

<style scoped>

</style>
